import React from 'react'
import { Layout, Header, Intro, SectionTitle } from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            Space is the distance between elements. The space settings here
            should be used in the construction of components not defined in the
            Currency Design System, or in arranging combinations of existing
            Currency components. These settings are defined as variables.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <p>
          Use these values to add consistent spacing between elements. The scale
          is based on a 16px (1rem) unit, which is the base typography size and
          a factor of common screen resolutions.
        </p>{' '}
        <table class="table last-right">
          <thead>
            <th>Token</th>
            <th>Variable</th>
            <th>Px</th>
          </thead>
          <tbody>
            <tr>
              <td>xxxsmall</td>
              <td>
                <span class="table__code">spacingXXXSmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>xxsmall</td>
              <td>
                <span class="table__code">spacingXXSmall </span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>xsmall</td>
              <td>
                <span class="table__code">spacingXSmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>small</td>
              <td>
                <span class="table__code">spacingSmall </span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>medium</td>
              <td>
                <span class="table__code">spacingMedium </span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>large</td>
              <td>
                <span class="table__code">spacingLarge </span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>xlarge</td>
              <td>
                <span class="table__code">spacingXLarge </span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>xxlarge</td>
              <td>
                <span class="table__code">spacingXXLarge </span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>xxxlarge</td>
              <td>
                <span class="table__code">spacingXXXLarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <SectionTitle className="l-margin-top--xxlarge">
          Using Spacing
        </SectionTitle>
        <p>
          Use less space between small components, or components that share a
          close functional relationship. Use more space between large
          components, or between components which are less functionally related.
          Coordinate small and large values, along with structural components
          like cards, to create visual groupings of related things. This helps
          users understand the interface and find what they’re looking for.
        </p>
        <p>
          For screens with specialized layouts, adjust overall spacing based on
          the density of the content. For example, a simple login screen on
          desktop display has more room to breathe, so more space can be used.
        </p>
        <table class="table">
          <thead>
            <th>Spacing</th>
            <th>Use</th>
          </thead>
          <tbody>
            <tr>
              <td>8px</td>
              <td>
                <span class="text">Between Labels and Form Fields</span>
              </td>
            </tr>
            <tr>
              <td>16px</td>
              <td>
                <span class="text">Between Buttons</span>
              </td>
            </tr>
            <tr>
              <td>16px</td>
              <td>
                <span class="text">Between Header and Application Titles</span>
              </td>
            </tr>
            <tr>
              <td>16px</td>
              <td>
                <span class="text">
                  Between Application Titles and Page Titles
                </span>
              </td>
            </tr>
            <tr>
              <td>24px</td>
              <td>
                <span class="text">Between Form Fields</span>
              </td>
            </tr>
            <tr>
              <td>24px</td>
              <td>
                <span class="text">Between Titles and Text Content</span>
              </td>
            </tr>
            <tr>
              <td>32px</td>
              <td>
                <span class="text">Between Form Fields and Button</span>
              </td>
            </tr>
            <tr>
              <td>32px</td>
              <td>
                <span class="text">Between Section Titles and Form Fields</span>
              </td>
            </tr>
            <tr>
              <td>32px</td>
              <td>
                <span class="text">Between Header and Page Titles</span>
              </td>
            </tr>
            <tr>
              <td>64px</td>
              <td>
                <span class="text">
                  Between Last Component (on screen) and Footer
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </Layout>
    </>
  )
}
